import { Box, Button, CircularProgress } from '@material-ui/core';

type FormSubmitButtonsMuiProps = {
  onCancel?: () => void;
  onSubmit?: () => void;
  loading?: boolean;
  disabled?: boolean;
  cancelLabel?: string;
  label?: string;
};

/** @deprecated Legacy MUI copy — migrate consumers to the Encore FormSubmitButtons and delete. */
export function FormSubmitButtonsMui({
  onCancel,
  onSubmit,
  disabled = false,
  loading = false,
  cancelLabel = 'Cancel',
  label = 'Save',
}: FormSubmitButtonsMuiProps) {
  return (
    <Box display="inline-flex" gridGap={8}>
      <Button
        onClick={onCancel}
        variant="outlined"
        color="default"
        disabled={loading}
        data-track-id="button.cancel"
        data-track-action="dismiss"
       data-track-source-anchor="d2a80bcbc5;form-submit-buttons-mui-button">
        {cancelLabel}
      </Button>
      <Button
        type="submit"
        color="primary"
        variant="contained"
        data-testid="submit-button"
        disabled={loading || disabled}
        onClick={onSubmit}
        data-track-id="button.submit"
        data-track-action="update"
        data-track-source-anchor="c1968e1e4b;form-submit-buttons-mui-button-2;high" {...(loading && {
          endIcon: (
            <CircularProgress
              data-testid="progress"
              size="1em"
              color="inherit"
            />
          ),
        })}
      >
        {label}
      </Button>
    </Box>
  );
}
